<h2 mat-dialog-title>Payment Response</h2>
<mat-dialog-content>
  <pre style="white-space: pre-wrap; word-break: break-word;">
    {{ msg }}
  </pre>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="copyToClipboard()">Copy</button>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
